import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IdeaTO, Page } from 'features/feedback/shared/feedback.types';

export type IdeaSort = 'top' | 'new';

interface Slice {
  items: IdeaTO[];
  sort: IdeaSort;
  page: number;
  hasMore: boolean;
  loading: boolean;
}

const getInitialState = (): Slice => ({
  items: [],
  sort: 'top',
  page: 0,
  hasMore: false,
  loading: false,
});

const flipVote = (state: Slice, id: number) => {
  const item = state.items.find((i) => i.id === id);
  if (!item) return;
  const next = !item.votedByMe;
  item.votedByMe = next;
  item.voteCount += next ? 1 : -1;
};

const ideasSlice = createSlice({
  name: 'ideas',
  initialState: getInitialState(),
  reducers: {
    ideasGet: (s, { payload }: PayloadAction<{ sort: IdeaSort; page?: number; reset?: boolean }>) => {
      s.loading = true;
      s.sort = payload.sort;
      if (payload.reset) {
        s.page = 0;
        s.items = [];
      }
    },
    ideasSet: (s, { payload }: PayloadAction<Page<IdeaTO>>) => {
      s.loading = false;
      s.page = payload.number;
      s.hasMore = payload.number < payload.totalPages - 1;
      s.items = payload.number === 0 ? payload.content : [...s.items, ...payload.content];
    },
    ideasError: (s) => {
      s.loading = false;
    },
    setSort: (s, { payload }: PayloadAction<IdeaSort>) => {
      s.sort = payload;
    },
    voteToggle: (s, { payload }: PayloadAction<number>) => flipVote(s, payload),
    voteRollback: (s, { payload }: PayloadAction<number>) => flipVote(s, payload),
  },
});

export default ideasSlice;
export const ideasReducer = ideasSlice.reducer;
export const ideasActions = ideasSlice.actions;
